'use client'

import SportsClientV2 from '@/src/app/[lang]/(lobby)/sports/SportsClientV2.tsx'
import SportsClientWidget from '@/src/app/[lang]/(lobby)/sports/SportsClientWidget.tsx'
import Loading from '@/src/components/Loading'
import useAuthGuard from '@/src/hooks/useAuthGuard.tsx'
import { useGetPreLiveQuery } from '@/src/services/games.tsx'

const sportsVersion = {
  isSecondVersionSB: function (url) {
    return /sb2integration/g.test(url)
  },
  isThirdVersionSB: function (url) {
    return /sb2widgetsstatic/g.test(url) || /sb2wsdk/g.test(url)
  },
}

const SportsClient = () => {
  const { isLoggedIn } = useAuthGuard()
  const { data } = useGetPreLiveQuery(
    { type: !isLoggedIn ? 'demo' : 'real' },
    { skip: isLoggedIn === undefined },
  )

  return (
    <>
      <Loading loading={!data} type='inline' className='top-1/2 !h-auto' />
      {sportsVersion.isThirdVersionSB(data?.url) && <SportsClientWidget />}
      {sportsVersion.isSecondVersionSB(data?.url) && <SportsClientV2 />}
    </>
  )
}

export default SportsClient
